import { PROJECTTASKSTATUS_SUCCESS, PROJECTTASKSTATUS_FAIL } from '../actionTypes';

const initialState = {
    user: null,
    loading: false
};

const projectTaskStatusReducer = (state = initialState, action) => {
    switch (action.type) {
        case PROJECTTASKSTATUS_SUCCESS:
            return {
                ...state,
                loading: true,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case PROJECTTASKSTATUS_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default projectTaskStatusReducer;
